/* eslint-disable quote-props */
import { Switch, styled } from "@mui/material";

const SwitchCustom = styled(Switch)(({ theme }) => ({
  display: "flex",
  width: 59,
  padding: 8,
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      "&+.MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 21,
    height: 21,
    transform: "translateY(1px)",
    background: "#FFFFFF",
  },
  "& .MuiSwitch-track": {
    borderRadius: 12,
    backgroundColor: theme.palette.taupe.main,
    opacity: 1,
    transform: "translateY(1.5px)",
  },
}));

export default SwitchCustom;
